/** Main navigation, shared by the header, mobile menu and footer. */
export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/work", label: "Work" },
  { to: "/about", label: "About" },
  { to: "/technologies", label: "Technologies" },
] as const;

export const CONTACT = {
  phoneDisplay: "+1 (519) 504-9076",
  phoneHref: "tel:+15195049076",
  email: "info@infinitudestack.com",
  location: "Kitchener, ON, Canada",
  calendly: "https://calendly.com/infinitudestack/30min",
} as const;

/** Social profiles linked from the live site. Also candidates for SAME_AS in seo/site.ts once confirmed. */
export const SOCIAL = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/infinitudestack/" },
  { label: "Facebook", href: "https://www.facebook.com/infinitudestack" },
  { label: "Instagram", href: "https://www.instagram.com/infinitudestack/" },
] as const;
